import dayjs from 'dayjs';
import { currencyFormatter } from '../../utils/utils';

export const setDataTableSource = (data, parkingList) => {
  const dataSource = data.map((item) => {
    const parking = parkingList?.find((park) => String(park.cates_id_int) === String(item.parkingCode));
    return {
      key: item.oid,
      'Número de operación': item.oid,
      'Id Externo': item.externalId,
      'Fecha de operación': dayjs(item.operationDate).format('DD-MM-YYYY'),
      'Fecha de deposito': dayjs(item.settlementDate).format('DD-MM-YYYY'),
      Estacionamiento: parking ? `${parking.cates_id_int} - ${parking.cates_descr_corta_str}` : '',
      Nombre: item.fullName,
      amount: item.totalAmount,
      Referencia: item.gsmReference,
      Total: currencyFormatter(item.totalAmount)
    };
  });
  const columns = Object.keys(dataSource[0] || {})
    .map((key) => {
      const hiddenColumns = ['key', 'amount'];
      if (!hiddenColumns.includes(key)) {
        return { title: key, dataIndex: key, key };
      }
      return null;
    })
    .filter((col) => col !== null);
  return { dataSource, columns };
};
